/**
 * @see https://developers.google.com/analytics/devguides/collection/ga4/reference/events?sjid=1228647551205989991-NC&hl=ja&client_type=gtm#login
 */
export interface LoginEvent {
  event: 'login'
}

const create = (): LoginEvent => ({
  event: 'login',
})

export const loginEventFactory = {
  create,
} as const
